import classNames from 'classnames';

import type { ReviewContentProps } from '../ReviewContent/ReviewContent';
import ReviewContent from '../ReviewContent/ReviewContent';

const ReviewCard = ({ className, showReadMore = true, ...props }: ReviewContentProps) => {
  return (
    <div
      className={classNames(
        'rounded-xl border border-primary-100 hover:border-secondary flex flex-col transition-colors p-5 min-h-80',
        className,
      )}
    >
      <ReviewContent className="flex-grow" showReadMore={showReadMore} {...props} />
    </div>
  );
};

export default ReviewCard;
